export default __webpack_public_path__ + "static/media/trash.df0bbe9d.svg";